import CheckIcon from "@mui/icons-material/Check";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

import Badge from "components/badge";
import Button from "components/button";
import Seat from "components/seat";

import { ReactComponent as ArrowDown } from "assets/images/arrowDown.svg";
import { ReactComponent as Block } from "assets/images/blockS.svg";
import Seating from "assets/images/seating.png";
import { useTranslation } from "i18n";
import React from "react";

function SeatMap({
  loading,
  errMsg,
  value,
  travelers,
  seats,
  reverseSeats,
  handelRemoveSeat,
  handelTraverlsSeats,
  getAllReversedSeats,
  handelSubmit,
  setTravelerIndex,
  handleChangeTab,
  state,
  travelerIndex,
  currency,
}) {
  const { t } = useTranslation();
  const isMobile = window.innerWidth <= 768;

  return (
    <div>
      <Box className="card-card bk-card bk-seat-intro">
        <Box display="flex" alignItems="center">
          <Box className="bk-seat-intro-img">
            <img className="seat-img" src={Seating} alt="seating" />{" "}
          </Box>
          <Box ml={2} className="bk-seat-intro-text">
            <p className="medium-font-size bolder bk-card-title">
              {t("booking.seats.title")}
            </p>
            <Box display="flex" mt={1} alignItems="center">
              <CheckIcon
                sx={{ fontSize: 18, color: "rgb(34, 154, 22)", mr: 1 }}
              />
              <p>{t("booking.seats.description")}</p>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className="card-card bk-card seats-container bk-seats-card" overflow="hidden">
        {loading ? (
          [...Array(3)]?.map((_, skeleton) => (
            <Box display="flex" justifyContent="space-between" key={skeleton}>
              <Box display="flex">
                {[...Array(3)]?.map((_, index) => (
                  <Box mx={1} key={index}>
                    <Skeleton
                      variant="text"
                      width={24}
                      height={34}
                      animation="wave"
                      sx={{ bgcolor: "#F1F3F6", marginBottom: 1 }}
                    />
                  </Box>
                ))}
              </Box>
              <Box display="flex">
                {[...Array(4)]?.map((_, index) => (
                  <Box display="flex" mx={1} key={index}>
                    <Skeleton
                      variant="text"
                      width={24}
                      height={34}
                      animation="wave"
                      sx={{ bgcolor: "#F1F3F6", marginBottom: 1 }}
                    />
                  </Box>
                ))}
              </Box>
              <Box display="flex">
                {[...Array(3)]?.map((_, index) => (
                  <Box display="flex" mx={1} key={index}>
                    <Skeleton
                      variant="text"
                      width={24}
                      height={34}
                      animation="wave"
                      sx={{ bgcolor: "#F1F3F6", marginBottom: 1 }}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          ))
        ) : errMsg ? (
          <div className="empty-data-msg bk-seatmap-empty">
            <span className="bk-seatmap-empty-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <path d="M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z" />
              </svg>
            </span>
            <h1 className="medium-font-size title-header">{errMsg}</h1>
          </div>
        ) : (
          <>
            <Box mb={4} className="bk-seat-tabs">
              <Tabs
                value={value}
                onChange={handleChangeTab}
                variant="scrollable"
                scrollButtons={false}
                aria-label="flight segments"
              >
                {seats?.map((flight, tab) => (
                  <Tab
                    key={tab}
                    label={
                      flight?.departure?.iataCode +
                      " → " +
                      flight?.arrival?.iataCode
                    }
                  />
                ))}
              </Tabs>
            </Box>
            <Box mb={6}>
              {travelers?.length > 0 && (
                <Box display="flex" mb={2} className="sticky-badges">
                  {travelers?.map(
                    (traveler, index) =>
                      state?.flight?.travelerPricings?.[index]?.travelerType !==
                        "HELD_INFANT" && (
                        <Badge
                          key={index}
                          className={`teal clickable ${
                            travelerIndex === index
                              ? "activeChosen"
                              : "inactiveChosen"
                          }`}
                          title={
                            traveler?.name?.firstName +
                            "." +
                            traveler?.name?.lastName?.charAt(0)
                          }
                          selectedSeat={
                            reverseSeats[index][traveler.id]?.seats?.find(
                              (i) => i.segmentId === seats[value]?.segmentId
                            )?.selectedSeat
                          }
                          iconClose
                          onClick={() => {
                            setTravelerIndex(index);
                          }}
                          onCloseClick={() =>
                            handelRemoveSeat(
                              reverseSeats[index][
                                travelers[index].id
                              ]?.seats?.find(
                                (i) => i.segmentId === seats[value]?.segmentId
                              )?.selectedSeat,
                              index
                            )
                          }
                        />
                      )
                  )}
                </Box>
              )}

              <Box textAlign="center" mb={2}>
                <p className="medium-font-size bolder bk-seatmap-title">
                  {t("booking.seats.selectOnMap")}
                </p>
                <Box
                  mt={1.5}
                  display="flex"
                  justifyContent={"center"}
                  alignItems="center"
                  gap={{ xs: 1, sm: 1, md: 1.5 }}
                  flexWrap="wrap"
                  className="bk-seat-legend"
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    className="seat-booking-wrapper bk-legend-chip"
                  >
                    <Block />
                    <p className="gray ms-2 align-self-end">
                      {t("booking.seats.available")}
                    </p>
                  </Box>

                  <Box
                    display="flex"
                    alignItems="center"
                    className="seat-booking-wrapper bk-legend-chip bk-legend-chip--selected"
                  >
                    <Block />
                    <p className="gray ms-2 align-self-end">
                      {t("booking.seats.selected")}
                    </p>
                  </Box>

                  <Box
                    className="light seat-booking-wrapper bk-legend-chip"
                    display="flex"
                    alignItems="center"
                  >
                    <Block style={{ opacity: 0.4 }} />
                    <p className="gray ms-2 align-self-end">
                      {t("booking.seats.blocked")}
                    </p>
                  </Box>
                </Box>
              </Box>

              <Box
                display="flex"
                justifyContent="center"
                className="test bk-seatgrid"
                position="relative"
              >
                {[
                  ...Array(seats[value]?.decks[0]?.deckConfiguration?.width),
                ]?.map((col, y) => (
                  <Box
                    display="flex"
                    flexDirection="column"
                    className={`column-${y}`}
                    key={y}
                  >
                    {[
                      ...Array(
                        seats[value]?.decks[0]?.deckConfiguration?.length
                      ),
                    ]?.map((_, x) => (
                      <React.Fragment key={x}>
                        {seats[value]?.decks[0]?.deckConfiguration
                          ?.startWingsRow === x &&
                          y === 0 && (
                            <div
                              className="left-wing"
                              style={{
                                height:
                                  (isMobile ? 32 : 70) *
                                    (seats[value]?.decks[0]?.deckConfiguration
                                      ?.endWingsX +
                                      1) +
                                  "px",
                                top:
                                  (isMobile ? 32 : 70) *
                                    seats[value]?.decks[0]?.deckConfiguration
                                      ?.startWingsRow +
                                  "px",
                              }}
                            />
                          )}
                        {seats[value]?.decks[0]?.deckConfiguration
                          ?.startWingsRow === x &&
                          y === 0 && (
                            <div
                              className="right-wing"
                              style={{
                                height:
                                  (isMobile ? 32 : 70) *
                                    (seats[value]?.decks[0]?.deckConfiguration
                                      ?.endWingsX +
                                      1) +
                                  "px",
                                top:
                                  (isMobile ? 32 : 70) *
                                    seats[value]?.decks[0]?.deckConfiguration
                                      ?.startWingsRow +
                                  "px",
                              }}
                            />
                          )}

                        <Seat
                          onClick={handelTraverlsSeats}
                          activeSeats={
                            reverseSeats?.length > 0 && travelers?.length > 0
                              ? getAllReversedSeats()
                              : []
                          }
                          style={{
                            pointerEvents:
                              seats[value]?.decks[0]?.seats?.find(
                                (i) =>
                                  i?.coordinates?.x === x &&
                                  i?.coordinates?.y === y
                              )?.travelerPricing?.[0]
                                ?.seatAvailabilityStatus === "AVAILABLE"
                                ? "all"
                                : "none",
                            opacity:
                              seats[value]?.decks[0]?.seats?.find(
                                (i) =>
                                  i?.coordinates?.x === x &&
                                  i?.coordinates?.y === y
                              )?.travelerPricing?.[0]
                                ?.seatAvailabilityStatus === "AVAILABLE"
                                ? 1
                                : 0.4,
                          }}
                          price={
                            seats[value]?.decks[0]?.seats?.find(
                              (i) =>
                                i?.coordinates?.x === x &&
                                i?.coordinates?.y === y
                            )?.travelerPricing?.[0]?.price?.total
                          }
                          seatNmber={
                            seats[value]?.decks[0]?.seats?.find(
                              (i) =>
                                i?.coordinates?.x === x &&
                                i?.coordinates?.y === y
                            )?.number
                          }
                          currency={currency}
                        />
                      </React.Fragment>
                    ))}
                  </Box>
                ))}
              </Box>
            </Box>
          </>
        )}
      </Box>
      <Button
        type="button"
        // onClick={() => {
        //   setActiveStep(3);
        //   window.scrollTo(0, 0);
        // }}
        onClick={handelSubmit}
        className="bigBtn primary-color booking"
      >
        {loading ? t("booking.seats.skip") : t("booking.actions.continue")}{" "}
        {state?.flightDetails?.return !== "One-way" && (
          <>
            -{" "}
            {t("booking.actions.days", {
              count: state?.flightDetails?.totalDays,
            })}
          </>
        )}{" "}
        <ArrowDown />
      </Button>
    </div>
  );
}

export default SeatMap;
